import React from "react";
import Navbar from "./components/navbar";
import CreateMiCeluComponent from "./create/create.component";
import CreateMiCeluProvider from "./create/provider/createMiCelu.provider";
import CreateUsedMiCeluProvider from "./create/used/provider/createUsedMiCelu.provider";
import CreateNewsMiCeluProvider from "./create/news/provider/createNewsMiCelu.provider";
import LogoAcinco from "../../assets/images/logo_acinco_white.png";

const IcaliPage = () => {
  return (
    <CreateMiCeluProvider>
      <CreateNewsMiCeluProvider>
        <CreateUsedMiCeluProvider>
          <div className="flex min-h-[100svh] flex-col bg-gradient-to-b from-white to-[#2D1366]">
            <Navbar />
            <main className="flex flex-1 items-center justify-center px-4 pb-8 pt-24">
              <div className="container mb-auto mt-auto max-w-7xl">
                <CreateMiCeluComponent />
              </div>
            </main>
            <footer className="flex w-full items-center justify-center py-4 text-white">
              Respaldado por{"   "}
              <img
                src={LogoAcinco}
                alt="logo_acinco"
                className="ml-2 max-h-14"
              />
            </footer>
          </div>
        </CreateUsedMiCeluProvider>
      </CreateNewsMiCeluProvider>
    </CreateMiCeluProvider>
  );
};

export default IcaliPage;
